import React from 'react'
import "./portafolio.css"
import IMG1 from "../../assets/portafolio-coronado.png" 
import IMG2 from "../../assets/portfolio2.jpg"

const Portafolio = () => {
  return (
    <section id='portafolio'>
      <h5>proyectos recientes</h5>
      <h2>MIS PROYECTOS</h2>
      <div className='container portafolio__container'>
        <article className='portafolio__item'>
            <div className='portafolio__item-image'>
              <img src={IMG1} alt="portafolio1" />
            </div>
            <h3 className='titulo__portafolio'>MI PORTAFOLIO</h3>
            <div className="portafolio__item-cta">
              <a href="https://github.com/BryanCoronado/BryanCoronado.github.io" className='btn ' target='_blank'>Github</a>
              <a href="https://bryancoronado.github.io/" className='btn btn-primary' target='_blank'>DEMO</a>
            </div>
        </article>

      </div>
    </section>
  )
}

export default Portafolio